import { McIcon } from "./icon.js"




export class McIconClosebook extends McIcon {
  constructor() {
    super()
    const templ = document.createElement("template")
    templ.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      class="lucide lucide-book-text h-4 w-4 text-indigo-600" aria-hidden="true">
      <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
      <path d="M8 11h8"></path>
      <path d="M8 7h6"></path>
  </svg>
`
    super.addHTML(templ)
  }
}



if (!window.customElements.get("mc-icon-closebook")) window.customElements.define("mc-icon-closebook", McIconClosebook)
